<div id="main" class="myw-content d-flex flex-column flex-fill">
    <!-- navbar -->
    <div class="myw-navbar">
        <div class="myw-inner myw-container d-flex flex-wrap">
            <nav class="nav nav-tabs">
                <a  class="nav-item nav-link active"  style="cursor: pointer;" (click)="loadCreateProposal()"
                [ngClass]="{active: isLoadCreateProposal, disabled: DisableCreate }" *ngIf="!showHeaderB() && !hideCreateProp()">Create Proposal</a>
                <a  class="nav-item nav-link active"  style="cursor: pointer;" (click)="loadCreateProposal()"
                [ngClass]="{active: isLoadCreateProposal, disabled: DisableCreate }" *ngIf="showHeaderB() && !hideCreateProp()">Edit Proposal</a>
                <!-- <a class="nav-item nav-link"  style="cursor: pointer;" *ngIf="hideCreateProp() && !fdsStatus()"  (click)="loadUploadExcel()"
                [ngClass]="{active: isLoadUploadExcel, disabled: DisableUpload}" id="uploadExceltemp">Upload Tickets &amp; Configure Domain Mapping</a>
                <a class="nav-item nav-link"  style="cursor: pointer;" *ngIf="!hideCreateProp() && !fdsStatus()" (click)="loadUploadExcel()"
                [ngClass]="{active: isLoadUploadExcel, disabled: DisableUpload}" id="uploadExceltemp">Upload Tickets &amp; Configure Domain Mapping</a> -->
                <a class="nav-item nav-link" [ngClass]="{active: isLoadUploadExcel, disabled: DisableUpload}" *ngIf="iomservice.isManualUpload"  style="cursor: pointer;" (click)="loadUploadExcel()"
                 id="uploadExceltemp">Upload Tickets</a>
                 <a class="nav-item nav-link" [ngClass]="{active: isLoadMapping, disabled: DisableUpload}" *ngIf="iomservice.isManualUpload"  style="cursor: pointer;" (click)="loadAttributeMapp()"
                 id="AttributeMapping">Attribute Mapping</a>
                <a class="nav-item nav-link" style="cursor: pointer;" *ngIf="hideCreateProp()" (click)="loadTextConf()"
                    [ngClass]="{active: isLoadTextConf}">Create Deepdive</a>
                <a class="nav-item nav-link" style="cursor: pointer;" *ngIf="!hideCreateProp()" (click)="loadTextConf()"
                    [ngClass]="{active: isLoadTextConf}">Create Deepdive</a>
            </nav>
        </div>
    </div>
    <!-- /navbar -->
</div>
<div *ngIf="isFDS==false">
    <app-create-proposal *ngIf="isLoadCreateProposal"></app-create-proposal>
    <app-text-conf *ngIf="isLoadTextConf"></app-text-conf>
    <app-upload-excel *ngIf="isLoadUploadExcel"></app-upload-excel>
    <app-attribute-mapping *ngIf="isLoadMapping"></app-attribute-mapping>
</div>
<div *ngIf="isFDS == true">  
    <app-create-proposal *ngIf="isLoadCreateProposal"></app-create-proposal> 
    <app-upload-excel *ngIf="isLoadUploadExcel == true && iomservice.isManualUpload == true"></app-upload-excel> 
    <app-attribute-mapping *ngIf="isLoadMapping == true && iomservice.isManualUpload == true"></app-attribute-mapping>
    <app-text-conf *ngIf="isLoadTextConf == true && iomservice.isManualUpload == true "></app-text-conf>
    <app-e2e-textconfig *ngIf="isLoadTextConf == true && iomservice.isManualUpload == false"></app-e2e-textconfig>
</div>